module.exports = __webpack_public_path__ + "static/media/LockSuccessIcon.aa8081f9.svg";